import React, { type PropsWithChildren } from 'react'

import { useTranslation } from 'react-i18next'

import { Render } from '@/shared/components/render-if'
import { cn } from '@/shared/lib'
import { formatToBRL } from '@/shared/utils/currency.utils'

interface ISimulacaoParcelasAgrupadasProps {
  isGrupoSaldo?: boolean
  parcelas: Array<{ valor: number; quantidade: number }>
}

const HeaderText = ({ children }: PropsWithChildren) => {
  return (
    <header className="space-x-2">
      <span className={cn('font-poppins text-sm tracking-wide text-gray-500', 'md:text-base')}>{children}</span>
    </header>
  )
}

const SimulacaoParcelasAgrupadas: React.FC<ISimulacaoParcelasAgrupadasProps> = ({
  isGrupoSaldo: isConclusao,
  parcelas,
}) => {
  const { t } = useTranslation('simulador')
  if (isConclusao) {
    return <HeaderText>{t('simulador.grupos.pagamento_na_entrega')}</HeaderText>
  }

  const parcelasAgrupadasPorValor = parcelas.reduce((acc: typeof parcelas, item) => {
    const existente = acc.find((p) => p.valor === item.valor)
    if (existente) existente.quantidade += item.quantidade
    else acc.push({ valor: item.valor, quantidade: item.quantidade })
    return acc
  }, [])

  return (
    <Render.If
      condition={parcelasAgrupadasPorValor.length >= 1}
      fallback={<HeaderText>{t('simulador.grupos.nenhuma_parcela')}</HeaderText>}
    >
      {() =>
        parcelasAgrupadasPorValor?.map((parcela) => (
          <header
            className={cn(
              'font-nunito flex flex-wrap items-center gap-2 text-sm break-words',
              'md:text-base',
              'lg:block lg:flex-nowrap lg:space-x-2 lg:text-base lg:tracking-wide',
            )}
            key={parcela.valor}
          >
            <span className="text-gray-700">{parcela.quantidade}x</span>
            <span className="lg:break-words">{formatToBRL(parcela.valor)}</span>
          </header>
        ))
      }
    </Render.If>
  )
}

export { SimulacaoParcelasAgrupadas }
